exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/search/ios-search.svg"));

// Module
exports.push([module.id, ".FLHctxUPOE3xQ4Ac01MSe{padding:20px 20px;border-bottom:1px solid #e0e0e0}._2oq1Xq4F7AZHYrOukIVyxG{border-radius:999px;border:1px solid #e0e0e0;height:40px;line-height:40px;outline:none;width:100%;padding:0 30px 0 45px;background:url(" + ___CSS_LOADER_URL___0___ + ") no-repeat 15px center/20px,#fff}._21TwVlgkuOR_cP9gdffSQy{margin-top:10px}._1jFbClon2xAE-wsplgg1i_{margin-top:10px;margin-bottom:-10px;color:#757575;font-size:15px}._2ySCvrUdeMK_fHp_UNO5V4{padding:20px;text-align:center}._2MLlIV-07EzzAdBDzt7dnI{font-style:italic;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"searchContainer": "FLHctxUPOE3xQ4Ac01MSe",
	"searchInput": "_2oq1Xq4F7AZHYrOukIVyxG",
	"chips": "_21TwVlgkuOR_cP9gdffSQy",
	"resultsCount": "_1jFbClon2xAE-wsplgg1i_",
	"resultsFooter": "_2ySCvrUdeMK_fHp_UNO5V4",
	"footerText": "_2MLlIV-07EzzAdBDzt7dnI"
};